// src/components/JuryModal.jsx
import React, { useState } from 'react';

const JuryModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="reg-button-2" onClick={() => setOpen(true)}>
        Коллегия Жюри 
      </button>

      {open && (
        <div className="reg-overlay" onClick={() => setOpen(false)}>
          <div className="reg-modal" onClick={e => e.stopPropagation()}>
            <button className="reg-close" onClick={() => setOpen(false)}>
              ×
            </button>

            <h2>КОЛЛЕГИЯ ЖЮРИ BRANDGLOBE HACKATHON 2025</h2>

            <div className="reg-section">
              <h3>1. Кто оценивает — состав и принципы формирования</h3>
              <p>
                Для оценки проектов BrandGlobe формирует коллегию жюри исключительно из топовых специалистов мирового уровня — лауреатов Effie и Cannes Lions, глобальных CMO, профессоров ведущих бизнес-школ и технических лидеров, внесших значимый вклад в развитие цифрового маркетинга. Ежегодно коллегия включает 20 независимых профессионалов из 14 стран СНГ, ЕС, Северной Америки и Азии. Ни один из судей не связан контрактами с командами-участницами или их работодателями, что гарантирует полную объективность оценки.
              </p>
            </div>

            <div className="reg-section">
              <h3>Квалификация жюри BrandGlobe Hackathon</h3>
              <p>Методика отбора экспертов (необходимо иметь минимум 3 пункта)</p>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>Параметр</th>
                      <th>Жесткое требование</th>
                      <th>Зачем это нужно</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Профиль</td>
                      <td>
                        Обязательно — топ‑лидер рынка маркетинга. Допустимы две категории:
                        <ul >
                          <li>академия (профессора и заведующие кафедрами маркетинга)</li>
                          <li>индустрия (CMO / креативные директора глобальных брендов)</li>
                        </ul>
                      </td>
                      <td>Дает многосторонний, но именно маркетинговый угол зрения.</td>
                    </tr>
                    <tr>
                      <td>Стаж</td>
                      <td>≥ 3–5 лет на руководящих или исследовательских должностях, влияющих на стратегию бренда</td>
                      <td>Опыт подтверждается CV + рекомендации; проверку проводит compliance-отдел МАМИ.</td>
                    </tr>
                    <tr>
                      <td>Достижения</td>
                      <td>
                        Минимум 2 из 4 пунктов:
                        <ul >
                          <li>международная награда (Effie, Cannes Lions, Webby, Red Dot и т. д.)</li>
                          <li>индекс цитирования Scopus ≥ 200 (для академиков)</li>
                          <li>запуск или курирование проектов с годовым маркетинг-бюджетом ≥ $50 млн (для индустрии)</li>
                          <li>членство в профильных ассоциациях (AMA, IAB Europe, EMAC)</li>
                        </ul>
                      </td>
                      <td>Обеспечивает высокий «порог качества» коллегии.</td>
                    </tr>
                    <tr>
                      <td>Публикации / патенты</td>
                      <td>Не менее 2 рецензируемых статей или 1 патента в martech / digital-design</td>
                      <td>Проверяется через CrossRef, WIPO, Google Patents.</td>
                    </tr>
                    <tr>
                      <td>Образование</td>
                      <td>Степень MBA, магистр или PhD, либо Executive Education из топ‑25 FT</td>
                      <td>Гарантирует стратегическое мышление и академическую базу.</td>
                    </tr>
                    <tr>
                      <td>Этика и независимость</td>
                      <td>Подписанное Statement of Independence + прохождение курса «Anti‑Corruption & Bias» (МАМИ Academy)</td>
                      <td>Исключает конфликт интересов и скрытое лоббирование.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="reg-section">
              <h3>Структура коллегии</h3>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>Сектор экспертизы</th>
                      <th>Доля</th>
                      <th>Кол‑во экспертов</th>
                      <th>Типичные позиции (все — профиль «маркетинг»)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Академический маркетинг</td>
                      <td>40 %</td>
                      <td>8</td>
                      <td>Профессора и заведующие кафедрами маркетинга, поведенческой экономики, кросс‑культурных коммуникаций</td>
                    </tr>
                    <tr>
                      <td>Корпоративный маркетинг</td>
                      <td>35 %</td>
                      <td>7</td>
                      <td>Глобальные CMO, вице‑президенты по маркетингу международных компаний, руководители in‑house бренд‑команд</td>
                    </tr>
                    <tr>
                      <td>Агентский / Креативный маркетинг</td>
                      <td>15 %</td>
                      <td>3</td>
                      <td>Главные стратеги и креативные директора сетевых рекламных агентств, руководители консалтингов по brand‑growth</td>
                    </tr>
                    <tr>
                      <td>Social & ESG‑маркетинг</td>
                      <td>10 %</td>
                      <td>2</td>
                      <td>Маркетологи высшего звена НКО и устойчивых брендов, специалисты по ESG‑брендингу и импакт‑коммуникациям</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>Средний совокупный опыт коллегии – 14,3 года; медиана – 12 лет.</p>
            </div>

            <div className="reg-section">
              <h3>География и международное представительство</h3>
              <p>
                14 стран на пяти континентах: Украина, Германия, Польша, Италия, Великобритания, США, Канада, Бразилия, ОАЭ, Казахстан, Япония, Сингапур, Индия, ЮАР.
              </p>
              <p>
                Рабочие языки жюри – английский (основной), украинский, русский, испанский, японский.
              </p>
              <p>
                Каждая заявка получает минимум одного судью с культурной экспертизой по одной из трех выбранных участниками стран‑фокусов.
              </p>
            </div>

            <div className="reg-section">
              <h3>4. Механизмы независимости</h3>
              <h4>COI‑скрининг</h4>
              <p>
                Автоматическое сопоставление LinkedIn / Crunchbase / ORCID профилей с данными участников. Алгоритм помечает пересечения работодателей, инвестиций, совместных научных работ.
              </p>
              <h4>Self‑recusal</h4>
              <p>
                Если эксперт подтверждает конфликт, система исключает его из оценки конкретного ID‑проекта; вместо него назначается запасной судья из пула резервистов (5 человек).
              </p>
              <h4>Blind Voting</h4>
              <p>
                До финального live‑питча ни один член жюри не знает названия команды, ФИО капитана, названия компании-работодателя или страны происхождения.
              </p>
              <h4>Арбитражная комиссия</h4>
              <p>
                Три старших судьи (академия + индустрия + венчур) мониторят «отклонения оценки > 2 σ». При споре проводят закрытое слушание, решение фиксируется протоколом и e‑signature.
              </p>
              <h4>Публичная отчетность</h4>
              <p>
                После церемонии публикуется обезличенный набор баллов и фабула обсуждения (без раскрытия авторов комментариев).
              </p>
            </div>

            <div className="reg-section">
              <h3>Независимость и прозрачность</h3>
              <ul className="brandhackathon__list">
                <li>каждый судья подписывает Conflict‑of‑Interest Statement;</li>
                <li>при совпадении работодателя или инвестиционного портфеля с командой система автоматического алертинга требует самоотвода;</li>
                <li>заседания фиксируются протоколами, а индивидуальные оценки хранятся в зашифрованной базе не менее трех лет.</li>
              </ul>
            </div>

            <div className="reg-section">
              <h3>2. Как оценивают — пошаговый механизм</h3>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>Этап</th>
                      <th>Период</th>
                      <th>Что происходит</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Анонимная техническая валидация</td>
                      <td>16‑24 сентября</td>
                      <td>
                        Техкомитет проверяет файлы, удаляет метаданные и присваивает проекту 12‑значный ID. Жюри видит только ID, трек и краткое описание без имен.
                      </td>
                    </tr>
                    <tr>
                      <td>Round 1 — дистанционное ревью</td>
                      <td>26 сентября – 5 октября</td>
                      <td>
                        Состав жюри делится между проектами (минимум из разных регионов). Оценка по 7 критериям → максимум 100 баллов. Баллы усредняются. Топ‑60 проходит дальше.
                      </td>
                    </tr>
                    <tr>
                      <td>Round 2 — синхронный коллоквиум</td>
                      <td>21‑25 октября</td>
                      <td>
                        Эксперты собираются в закрытых Zoom‑сессиях, обсуждают расхождения >15 баллов, приводят к консенсусу. Итог фиксируется электронной подписью.
                      </td>
                    </tr>
                    <tr>
                      <td>Хакатон & live‑питч</td>
                      <td>1‑3 ноября</td>
                      <td>
                        Жюри наблюдает стендапы в режиме «теневого слушателя» (без права давать советы). Во время финального питча раскрываются лица команд; судьи задают вопросы.
                      </td>
                    </tr>
                    <tr>
                      <td>Финальный подсчет</td>
                      <td>3‑4 ноября</td>
                      <td>
                        Система складывает: 60 % — средний балл Round 1/2, 30 % — оценка live‑питча, 10 % — бонусы (буткемп, open‑source, посещаемость вебинаров). Рейтинг закрывается блокчейн‑хешем.
                      </td>
                    </tr>
                    <tr>
                      <td>Публикация отчетов</td>
                      <td>5 ноября</td>
                      <td>
                        Каждая команда получает PDF с разбивкой баллов, суммарными комментариями и рекомендациями; публикация победителей на сайте.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="reg-section">
              <h3>3. Балльная система и критерии</h3>
              <p>
                Единая шкала 0‑10 по каждому подпараметру, умноженная на вес категории. Примеры:
              </p>
              <ul className="brandhackathon__list">
                <li>Strategic Positioning (вес 20 %) → 0‑10 × 2 = 0‑20 баллов.</li>
                <li>Soft‑skills Leader (вес 15 %) → 0‑10 × 1.5 = 0‑15 баллов.</li>
              </ul>
              <p>
                Полный рубрикатор (Mastermind, Navigator, Trailblazer и т.д.) опубликован здесь. Жюри пользуется единой онлайн‑формой с чек‑боксами и полем для текстового фидбэка (≥250 зн. на критерий).
              </p>
              <p>
                Контроль честности: система «Judge Variance Index» сигнализирует, если оценка эксперта отклоняется >2σ от среднего. Такое ревью отправляется на повторную кросс‑проверку председателю секции. Живое обсуждение записывается, аудиофайлы хранятся в зашифрованном S3‑хранилище, доступ получает только арбитражная комиссия при апелляциях.
              </p>
            </div>

            <div className="reg-section">
              <h3>4. Международное представительство</h3>
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>Регион</th>
                      <th>% судей</th>
                      <th>Роль в процессе</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ЕС</td>
                      <td>35 %</td>
                      <td>Модерируют дискуссию о культурной адаптации и ESG‑подходах.</td>
                    </tr>
                    <tr>
                      <td>СНГ</td>
                      <td>25 %</td>
                      <td>Проверяют релевантность решения рынкам Восточной Европы и Центральной Азии.</td>
                    </tr>
                    <tr>
                      <td>Северная Америка</td>
                      <td>20 %</td>
                      <td>Фокус на финансовой модели, венчурном потенциале и data‑privacy.</td>
                    </tr>
                    <tr>
                      <td>Азия‑Тихоокеанский</td>
                      <td>15 %</td>
                      <td>Оценивают масштабируемость в высококонкурентных digital‑экосистемах.</td>
                    </tr>
                    <tr>
                      <td>Латинская Америка / MENA / Африка</td>
                      <td>5 %</td>
                      <td>Вносят экспертизу emerging markets и social‑impact‑инициатив.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default JuryModal;
